module.exports = __webpack_public_path__ + "static/media/ic_phone.1246ebc7.svg";